export const easingSeconds = "0.6s";
export const zIndexTop = 9999;
export const mobileHeaderHeight = 60;
export const desktopHeaderHeight = 154;
export const scrollToDesktopNoHero = 35;
export const scrollToDesktopWithHero = 100;
export const scrollToTabletWithHero = 75;
export const scrollToMobileWithHero = 50;
export const scrollToDesktopHeroSearchBar = 300;
export const scrollToTabletHeroSearchBar = 300;
export const scrollToMobileHeroSearchBar = 170;
export const desktopDropdownMenuShadow =
    "box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.164336)";
